module.exports = __webpack_public_path__ + "static/media/Orpyx-SI-Logo.20f1a03c.svg";